import React from "react";

export const Tag = ({ contents }) => {
    return (
        <div>
            <label>{contents}</label>
        </div>
    );
};
